import { render, staticRenderFns } from "./SigninT.vue?vue&type=template&id=0bed0a1c"
import script from "./SigninT.vue?vue&type=script&lang=js"
export * from "./SigninT.vue?vue&type=script&lang=js"
import style0 from "./SigninT.vue?vue&type=style&index=0&id=0bed0a1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports